module.exports = __webpack_public_path__ + "media/svg/img-sequislogo-7e20dbc2.svg";